module.exports = __webpack_public_path__ + "img/step-2.6952d57b.png";